import React, { FC } from 'react';

import { Flex, IBoxProps } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import theme from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';

import i18n from '../../utils/i18n';

type OverridePanelProps = Pick<IBoxProps, 'backgroundColor'> & {
  title: string;
  subtitle?: string;
  tooltipContent?: string;
  onResetClick: () => void;
  resetDataTestId?: string;
};

const OverridePanel: FC<OverridePanelProps> = ({
  title,
  tooltipContent,
  subtitle,
  backgroundColor = 'pink500',
  onResetClick,
  resetDataTestId,
}) => {
  return (
    <Flex
      display="inline-flex"
      p="0 5px"
      lineHeight="18px"
      fontSize="13px"
      backgroundColor={backgroundColor}
    >
      <Tooltip
        content={tooltipContent}
        placement={Tooltip.PLACEMENTS.LEFT}
        shouldWrapChildren={false}
      >
        {`${title} ${subtitle} | `}
        <LinkButton
          data-testid={resetDataTestId}
          style={{
            lineHeight: '13px',
            cursor: 'pointer',
            color: theme.colors.white,
          }}
          onClick={onResetClick}
        >
          {i18n.t('RESET')}
        </LinkButton>
      </Tooltip>
    </Flex>
  );
};

export default OverridePanel;
